import { Component, OnInit, Input, TemplateRef, ViewChild, OnChanges, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { saveAs } from '@progress/kendo-file-saver';
import { dateFieldName } from '@progress/kendo-angular-intl';
import { PHBHPFeaturePackageChcService } from 'src/app/chc/ph-bhp-feature-package-chc.service';
import { ActivatedRoute } from '@angular/router';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../ph-bhp-feature-package-insitution-management.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-webkess-report',
  templateUrl: './webkess-report.component.html',
  styleUrls: ['./webkess-report.component.css']
})
export class WebkessReportComponent implements OnInit, OnDestroy {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  subscription: Subscription;
  resultSubscription: Subscription;
  checkStatusIntegrations: any;
  gridData: any[];
  userData;
  isEmptyData;
  modalRef: BsModalRef;
  searchText;
  insitutionId;
  institutionData: any;
  countryId: any;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  fields: any[] = [{ field: 'chcImportTypeTrl', title: 'WEBKESS_INTEGRATION.IMPORT.TYPE' },
  { field: 'chcImportId', title: 'WEBKESS_INTEGRATION.IMPORT.ID' },
  { field: 'chcImportStatus', title: 'WEBKESS_INTEGRATION.IMPORT.STATUS' },
  {
    field: 'chcImportDateTime', title: 'WEBKESS_INTEGRATION.DATE_TIME', 'ngTemplate': (dataItem) => {
      if (dataItem.chcImportDateTime) {
        const date = this.layoutService.convertUTCDateToLocalDate(new Date(dataItem.chcImportDateTime));
        //const lang = localStorage.getItem('selectedlanguage');
        var lang = localStorage.getItem('selectedlanguage');
        if (lang === 'en') {
          lang = 'en-GB';
        }
        return date.toLocaleDateString(lang, { month: '2-digit', day: '2-digit', year: 'numeric' }) + ' '
          + date.toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
      } else {
        return '';
      }
    }
  }];

  actionItems: any[] = [];

  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'WEBKESS_INTEGRATION.REPORTS_1',
    itemsPerPageLabel: 'WEBKESS_INTEGRATION.REPORTS_PER_PAGE'
  };

  departmentModelGridEdit: any = new UntypedFormGroup({
    departmentName: new UntypedFormControl('', Validators.compose([Validators.required, Validators.maxLength(60)]))
  });
  packageId: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: PHBHPFeaturePackageChcService,
    private mgmtService: PHBHPFeaturePackageInsitutionManagementService,
    private layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    public appConfig: AppConfig) { }

  ngOnInit() {
    this.insitutionId = this.activatedRoute.snapshot.parent.params.id;
    this.packageId = this.activatedRoute.snapshot.parent.params.packageId;
    this.actionItems = [
      {
        name: this.translate.instant('WEBKESS_INTEGRATION.IMPORT.FILE'),
        imgSrc: 'assets/img/icons/csv_blue.png',
        onClick: (dataItem) => {
          this.service.getCHCIntegerationDataById(dataItem.chcImportId, 'input').subscribe(res => {
            const dataURI = 'data:text/plain;base64,' + res.data;
            const fileName = this.getFileName(true);
            saveAs(dataURI, `${fileName}.csv`);
          });
        }
        , canShow: (dataItem) => {
          if (dataItem && dataItem.chcImportType == 'Observation Intervals') {
            return false;
          }
          return true;
        }
      },
      {
        name: this.translate.instant('WEBKESS_INTEGRATION.RESULT_FILE'),
        imgSrc: 'assets/img/icons/zip_blue.png',
        onClick: (dataItem) => {
          this.service.getCHCIntegerationDataById(dataItem.chcImportId, 'response').subscribe(res => {
            const dataURI = 'data:text/plain;base64,' + res.data;
            const fileName = this.getFileName(false);
            saveAs(dataURI, `${fileName}.zip`);
          });
        }
        /*,canShow: (dataItem) => {
          if(dataItem && dataItem.chcImportStatus == 'IMPORT_FINISHED_ERRORS'){
            return false;
          }
          return true;
        }*/
      },
      {
        name: "Skipped observations",
        imgSrc: 'assets/img/icons/txt_blue.png',
        onClick: (dataItem) => {
          const dataURI = 'data:text/plain,' +
            this.translate.instant('WEBKESS_INTEGRATION.MULTISELECTION_WARNING') + ": " +
            dataItem.skippedObservations;
          const fileName = this.getMultiselectionWarningFileName();
          saveAs(dataURI, `${fileName}.txt`);
        }
        , canShow: (dataItem) => {
          if (dataItem && dataItem.skippedObservations != null && dataItem.skippedObservations.length > 0) {
            return true;
          }
          else return false;
        }
      }
    ];

    this.getCHCIntegerationLog();
    this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.getCHCIntegerationLog();
    });
    this.resultSubscription = this.mgmtService.webKessUploadResult.subscribe(_ => {
      this.getCHCIntegerationLog();
    });
    this.service.checkPendingIntegrations(this.insitutionId).subscribe((updatedIntegrations: any) => { });
    this.checkStatusIntegrations = setInterval(() => {
      this.service.checkPendingIntegrations(this.insitutionId).subscribe((updatedIntegrations: any) => {
        if (updatedIntegrations.length > 0) {
          this.getCHCIntegerationLog();
        }
      });
    }, 60 * 1000);
  }
  syncCHCIntegration() {
    this.service.syncCHCIntegration().subscribe();
    this.layoutService.showSuccess(this.layoutService.translateText('WEBKESS_INTEGRATION.SYNC.INITIATED'));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    if (this.resultSubscription) {
      this.resultSubscription.unsubscribe();
    }

    clearInterval(this.checkStatusIntegrations);
  }

  getCHCIntegerationLog() {
    this.layoutService.showLoader = true;
    this.service.getwebKessIntegerationLogByInstitutionId(this.insitutionId).subscribe(res => {
      this.layoutService.showLoader = false;
      if (!res) {
        this.layoutService.showError(this.layoutService.translateText('BACKEND_SERVICES.CHC_RECORD_NOT_FOUND'));
        this.isEmptyData = true;
        return;
      }
      res.forEach(element => {
        if (element.chcImportStatus == 'IMPORT_FINISHED_ERRORS') {
          element.chcImportStatus = 'IMPORT_FINISHED_WARNINGS';
        }
        switch (element.chcImportType) {
          case 'HAND-KISS':
            element.chcImportTypeTrl = this.translate.instant('WEBKESS_INTEGRATION.HAND_KISS');
            break;
          case 'Observation Intervals':
            element.chcImportTypeTrl = this.translate.instant('WEBKESS_INTEGRATION.OBSERVATION_INTERVALS');
            break;
          case 'Observations':
            element.chcImportTypeTrl = this.translate.instant('WEBKESS_INTEGRATION.OBSERVATIONS');
            break;
          case 'Interval Deletion':
            element.chcImportTypeTrl = this.translate.instant('WEBKESS_INTEGRATION.INTERVAL_DELETION');
            break;
        }
      });
      let that = this;
      this.gridData = res.map(item => this.manageGrid(item, that));
      this.isEmptyData = false;
    }, err => {
      this.layoutService.showLoader = false;
    });
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem, rowIndex) {
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' }));
  }

  delete() { }

  getFileName(isInputFile: boolean) {
    const dateInfo = this.layoutService.getDateForFileName();
    const packageName = this.getPackageTextForFileName();
    const ioType = isInputFile ? this.layoutService.translateText('input') : this.layoutService.translateText('output');
    return `${dateInfo}_webKess_${ioType}_${packageName}`;
  }

  getMultiselectionWarningFileName() {
    const dateInfo = this.layoutService.getDateForFileName();
    const packageName = this.getPackageTextForFileName();
    const ioType = "warnings"
    return `${dateInfo}_webKess_${ioType}_${packageName}`;
  }

  getPackageTextForFileName() {
    return this.packageId === '1' ? 'MHS' : this.packageId === '2' ? 'Observe' : 'HygienePlatform';
  }

  onSearchTextChanged(text: string): void {
    this.searchText = text;
  }

  manageGrid(row, that) {
    if (row.chcImportDateTime) {
      const date = this.layoutService.convertUTCDateToLocalDate(new Date(row.chcImportDateTime));
      //const lang = localStorage.getItem('selectedlanguage');
      var lang = localStorage.getItem('selectedlanguage');
      if (lang === 'en') {
        lang = 'en-GB';
      }
      row.chcImportDateTime = date.toLocaleDateString(lang, { month: '2-digit', day: '2-digit', year: 'numeric' }) + ' '
        + date.toLocaleTimeString(lang, { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    } else {
      row.chcImportDateTime = '';
    }
    return row;
  }
}
